import { lazy } from 'react';
import { widgetRegistry } from '../../../core/widgets/WidgetRegistry';
import { WallboxStatsWidget } from './WallboxStatsWidget';
import { WallboxQuickActionsWidget } from './WallboxQuickActionsWidget';

// Charts load recharts only when the widget is shown.
const WallboxEnergyChartWidget = lazy(() => import('./WallboxEnergyChartWidget').then(m => ({ default: m.WallboxEnergyChartWidget })));
const WallboxRevenueChartWidget = lazy(() => import('./WallboxRevenueChartWidget').then(m => ({ default: m.WallboxRevenueChartWidget })));

/**
 * Register all Wallbox widgets
 */
export function registerWallboxWidgets() {
    widgetRegistry.register({
        id: 'wallbox-stats',
        title: 'Wallbox Statistiken',
        description: 'Übersicht über Ladevorgänge und Umsatz',
        component: WallboxStatsWidget,
        category: 'wallbox',
        requiredPermission: 'wallbox',
        defaultSize: 'full',
        defaultEnabled: true,
        order: 10,
    });

    widgetRegistry.register({
        id: 'wallbox-energy-chart',
        title: 'Ladeenergie',
        description: 'Verlauf der geladenen Energie (kWh)',
        component: WallboxEnergyChartWidget,
        category: 'wallbox',
        requiredPermission: 'wallbox',
        defaultSize: 'medium', // Half width on desktop
        defaultEnabled: true,
        order: 20,
    });

    widgetRegistry.register({
        id: 'wallbox-revenue-chart',
        title: 'Umsatz',
        description: 'Verlauf des Umsatzes (€)',
        component: WallboxRevenueChartWidget,
        category: 'wallbox',
        requiredPermission: 'wallbox',
        defaultSize: 'medium', // Half width on desktop
        defaultEnabled: true,
        order: 30,
    });

    widgetRegistry.register({
        id: 'wallbox-quick-actions',
        title: 'Schnellzugriff',
        description: 'Wichtige Links',
        component: WallboxQuickActionsWidget,
        category: 'wallbox',
        requiredPermission: 'wallbox',
        defaultSize: 'small',
        defaultEnabled: true,
        order: 40,
    });
}
